var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7139_20404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6667 10.75H43C41.0292 10.75 39.4167 12.3625 39.4167 14.3333V20.1025C39.4167 20.1025 39.4167 20.1025 39.4525 20.1383L57.3692 36.2633C59.6267 38.27 60.9167 41.2083 60.9167 44.2542V46.5833H68.0833V53.75H60.9167V60.9167H68.0833V68.0833H60.9167V75.25H71.6667C73.6375 75.25 75.25 73.6375 75.25 71.6667V14.3333C75.25 12.3625 73.6375 10.75 71.6667 10.75ZM53.75 25.0833H46.5833V17.9167H53.75V25.0833ZM68.0833 39.4167H60.9167V32.25H68.0833V39.4167ZM68.0833 25.0833H60.9167V17.9167H68.0833V25.0833Z",
    fill: "#E1E1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75 71.6667V44.2542C53.75 43.2508 53.32 42.2833 52.5675 41.6025L34.6508 25.4775C33.97 24.8325 33.11 24.5458 32.25 24.5458C31.39 24.5458 30.53 24.8683 29.8492 25.4775L11.9325 41.6025C11.18 42.2475 10.75 43.215 10.75 44.2542V71.6667C10.75 73.6375 12.3625 75.25 14.3333 75.25H21.5C23.4708 75.25 25.0833 73.6375 25.0833 71.6667V57.3333H39.4167V71.6667C39.4167 73.6375 41.0292 75.25 43 75.25H50.1667C52.1375 75.25 53.75 73.6375 53.75 71.6667Z",
    fill: "#E1E1E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7139_20404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBcIcon);
export default __webpack_public_path__ + "static/media/default-bc-icon.62421e9dda1c0d641a42095ebe36af08.svg";
export { ForwardRef as ReactComponent };